import { BaseClient } from './BaseClient'

export class OnboardingApi extends BaseClient {
  getSteps = this.createRequest({
    url: '/api/user/onboarding/progress',
    method: 'get',
  })

  setStep = (data) => {
    return this.createRequest({
      url: `/api/user/onboarding/complete-step`,
      method: 'post',
      data,
    })()
  }
}
